import template from './parking-price-enter.jade';

export default angular
    .module('cian.addForm.parkingPriceEnter', ['cian.addForm.helperPriceCurrencySelect'])
    .directive('cianAfAboutObjectParkingPriceEnter', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        link(scope, element, attrs, ctrl) {
            let parkingPrice = ctrl.getParking(ctrl.ad).priceEntry;
            // save and restore value
            scope.$watch(() => ctrl.getParking(ctrl.ad).isFree, isFree => {
                const isParkingExists = ctrl.isParkingExists(ctrl.ad);

                if (!isParkingExists) {
                    return;
                }

                const parking = ctrl.getParking(ctrl.ad);

                if (isFree === true) {
                    parkingPrice = parking.priceEntry;
                    parking.priceEntry = null;
                } else {
                    parking.priceEntry = parkingPrice;
                }
            });
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.ad.building = this.ad.building || {};
            this.ad.building.parking = this.ad.building.parking || {};

            this.isParkingExists = ad => {
                if (!ad.building || !ad.building.parking) {
                    return false;
                }

                return true;
            };

            this.getParking = ad => {
                const building = ad.building || {};
                const parking = building.parking || {};

                return parking;
            };
        }],
        controllerAs: 'parkingPriceEnter',
        template,
    }))
    .name;
